import request from '@/api/request';

export function loadMenu(name, lang) {
  const params = {
    name: name,
    lang: lang
  };
  return request({
    url: '/menus',
    method: 'get',
    params
  });
}

export function loadLanguages() {
  const params = {};
  return request({
    url: '/languages',
    method: 'get',
    params
  });
}

export function getSingle(slug) {
  return request({
    url: '/' + slug,
    method: 'get'
  });
}

export function getArticle(slug) {
  return request({
    url: '/articles?slug=' + slug,
    method: 'get'
  });
}

export function getArticleById(id) {
  return request({
    url: '/articles/' + id,
    method: 'get'
  });
}

export function getPage(slug) {
  const parameters = {
    slug
  };
  return request({
    url: '/pages?slug=' + slug,
    method: 'get',
    parameters
  });
}

export function getPageById(id) {
  return request({
    url: '/pages/' + id,
    method: 'get'
  });
}

export function getCollection(name, params = {}) {
  return request({
    url: `/${name}/`,
    method: 'get',
    params
  });
}
